import Loader from 'components/Loader'
import PostsSlider from 'components/PostsSlider'
import ProductBlock from 'components/ProductBlock'
import SectionBlock from 'components/SectionBlock'
import React, { Fragment, useEffect, useState } from 'react'
import HomePageService from 'services/HomePageService'
import useCache from 'store/CacheProvider'
import useConfig from 'store/ConfigProvider'
import {
  HomeBrandsContainer,
  HomeContainer,
  HomeTopContainer,
} from 'style/Home.style'
import SliderAndCategory from './components/SliderAndCategory'
import BrandsSlider from './components/BrandsSlider'
import { pageViewEvent } from 'services/conversionevents'
import MobileCategorySlider from './components/MobileCategorySlider'
import { MobileAndTabletView } from 'components/DeviceDetect'

const HomePage = () => {
  const { getCache } = useCache()
  const [suggestions, setSuggestions] = useState(null)
  const [homepage, setHomepage] = useState(
    getCache('HOMEPAGE', {
      blocks: [],
      blogs: [],
      nocache: true,
    })
  )
  const [brands, setBrands] = useState([])

  const { isLoaded } = useConfig()

  useEffect(() => {
    HomePageService.getSuggestions().then(suggestionBlock => {
      if (!suggestionBlock || !suggestionBlock.products) return
      setSuggestions(suggestionBlock)
    })
    HomePageService.getHomePage().then(home => {
      document.title = 'Citrus.ge - ყველაზე დიდი ინტერნეტ მაღაზია'
      setHomepage(home)
    })
    HomePageService.getBrands().then(brands => {
      setBrands(brands.homepageBrands)
    })
    pageViewEvent()
  }, [])

  if (!isLoaded) {
    return <Loader visible={true} type="ThreeDots" />
  }

  return (
    <Fragment>
      <MobileAndTabletView>
        <MobileCategorySlider />
      </MobileAndTabletView>
      <HomeTopContainer>
        <SliderAndCategory />
      </HomeTopContainer>
      <HomeBrandsContainer>
        <BrandsSlider brands={brands} />
      </HomeBrandsContainer>

      <HomeContainer>
        {homepage.blocks.length ? (
          <ProductBlock
            key={homepage.blocks[0].id}
            block={homepage.blocks[0]}
          />
        ) : null}
        {suggestions && suggestions.products.length ? (
          <ProductBlock block={suggestions} />
        ) : null}
        {(homepage.blocks || []).map((block, i) => {
          if (i > 0) {
            return <ProductBlock key={block.id} block={block} />
          }
          return null
        })}

        {homepage.blogs.length ? (
          <SectionBlock title="ბლოგი">
            <PostsSlider posts={homepage.blogs || []} />
          </SectionBlock>
        ) : (
          <Loader visible={true} type="ThreeDots" notFull={true}></Loader>
        )}
      </HomeContainer>
    </Fragment>
  )
}

export default HomePage
